import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useDispatch } from "react-redux";
import {
  // clearAllConversationApi,
  deleteClassesApi,
  getChoiceApi,
} from "../../redux/action/UserAction";

// Slide transition animation for the dialog
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// Main alert dialog component
export default function AlertDialogSlide({
  open, // controls dialog visibility
  setOpen, // function to update dialog visibility
  setShouldFetch, // flag used to determine deletion vs clear-all
  deleteId, // id to be deleted
  shouldFetch,
}) {
  const dispatch = useDispatch();

  // Function placeholder for clearing all (currently not used)
  const handleDelete = async () => {
    // dispatch(clearAllConversationApi(setOpen));
  };
  // console.log("id for delte in alertdialog", deleteId);
  // console.log("open for delte in alertdialog", open);
  // console.log("shouldFetch for delte in alertdialog", shouldFetch);

  // Function to delete a specific item and refresh the choices list
  const deleteOnsubmit = () => {
    try {
      dispatch(deleteClassesApi(setOpen, setShouldFetch, deleteId));
      dispatch(getChoiceApi());
    } catch (error) {
      console.error("Error in deleteOnsubmit:", error);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{ fontFamily: "lufga" }}>
          {/* Dynamic title based on type of action */}
          {`Are you sure you want to ${
            setShouldFetch ? "delete?" : "clear all?"
          }`}
        </DialogTitle>

        <DialogActions>
          {/* Cancel button */}
          <Button
            variant="outlined"
            sx={{
              fontFamily: "lufga",
              color: "black",
              border: "1px solid black",
            }}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>

          {/* Proceed button triggers appropriate delete action */}
          <Button
            variant="contained"
            sx={{ fontFamily: "lufga", backgroundColor: "black" }}
            onClick={setShouldFetch ? deleteOnsubmit : handleDelete}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
